import React, { lazy, Suspense } from "react";
import { SubHeading } from "../Components";

const SummaryBody = lazy(() => import("./SummaryBody"));

const Summary = () => {
  return (
    <>
      <SubHeading subTitle="Summary" />

      <Suspense>
        <SummaryBody />
      </Suspense>
    </>
  );
};

export default Summary;
